import { Injectable } from "@angular/core";
import { ClientsService } from "./clients/clients.service";
import { ClientUsersService } from "./client-users/client-users.service";
import { ClientRolesService } from "./client-roles/client-roles.service";
import { AdminUsersService } from "./admin-users/admin-users.service";
import { HttpClient } from "@angular/common/http";
import { GeoPrioritiesService } from "./geo-priorities/geo-priorities.service";
import { GeoIpExceptionsService } from "./geo-ip-exceptions/geo-ip-exceptions.service";
import { RegulationsService } from "./regulations/regulations.service";
import { GeoRegulationMapsService } from "./geo-regulation-maps/geo-regulation-maps.service";
import { ConsentPermissionsService } from "./consent-permissions/consent-permissions.service";
import { ComplianceInputService } from "./compliance-inputs/compliance-input.service";
import { ClientWebhooksService } from "./client-webhooks/client-webhooks.service";
import { ClientSystemsService } from "./client-systems/client-systems.service";
import { ClientFormsService } from "./client-forms/client-forms.service";
import { LegalActivityErrorsService } from "./legal-activity-errors/legal-activity-errors.service";
import { LegalActivitiesService } from "./legal-activities/legal-activities.service";
import { ClientRegulationsService } from "./client-regulations/client-regulations.service";
import { ClientRegulationConfigurationsService } from "./client-regulation-configurations/client-regulation-configurations.service";
import { RightRequestConfigsService } from "./right-request-configs/right-request-configs.service";
import { ClientEmailTemplatesService } from "./client-email-templates/client-email-templates.service";
import { ForgottenUsersService } from "./forgotten-users/forgotten-users.service";
import { RightRequestService } from "./right-requests/right-requests.service";
import { HitlTemplatesService } from "./hitl-templates/hitl-templates.service";
import { HitlTasksService } from "./hitl-tasks/hitl-tasks.service";
import { BusinessUnitsService } from "./business-units/business-units.service";
import { GeoSummaryService } from "./geo-summary/geo-summary.service";
import { PreferenceChannelService } from "./preference-channel/preference-channel.service";
import { PreferenceWhitelistService } from "./preference-whitelist/preference-whitelist.service";
import { PreferenceFrequenciesService } from "./preference-frequency/preference-frequency.service";
import { CorePreferencesService } from "./core-preferences/core-preferences.service";
import { CorePreferenceIntegrationService } from "./core-preference-integration/core-preference-integration.service";
import { CoreContactService } from "./core-contact/core-contact.service";
import { PreferenceAgentsService } from "./preference-agent/preference-agents.service";
import { PreferencePageService } from "./preference-page/preference-page.service";
import { PreferenceFormService } from "./preference-form/preference-form.service";
import { PreferenceOptionService } from "./preference-option/preference-option.service";
import { PreferenceCatalogService } from "./preference-catalog/preference-catalog.service";
import { ContactService } from "./contact/contact.service";
import { ContactDetailsService } from "./contact-details/contact-details.service";
import { ContactDetailsHistoryService } from "./contact-details-history/contact-details-history.service";
import { ContactPreferenceService } from "./contact-preference/contact-preference.service";
import { ContactPreferenceHistoryService } from "./contact-preference-history/contact-preference-history.service";
import { PreferenceWebhookService } from "./preference-webhooks/preference-webhooks.service";
import { PreferenceDashboardService } from "./preference-dashboard/preference-dashboard.service";
import { AIPreferencePageService } from "./ai-preference-page/ai-preference-page.service";
import { AIPromptService } from "./ai-prompt/ai-prompt.service";
import { AITokenUsageService } from "./ai-token-usage/ai-token-usage.service";
import { AIAgentService } from "./agent/ai-agent.service";
import { PreferenceAnalyticsService } from "./preference-analytics/preference-analytics.service";
import { PreferenceFlowReportService } from "./preference-flow-report/preference-flow-report.service";
import { TranslationsService } from "./translations/translations.service";
import { TranslationSettingsService } from "./translation-settings/translation-settings.service";
import { NotificationsService } from "./notifications/notifications.service";



/**
 * The API service is a consumable that is an SDK that gives any 4Thought Application an easy wrapper around the 4Comply API
 * If you want to just inject one of the services, you can also do that instead.
 *
 * For instance, in order to access the client users, you could run:
 * let apiService = new APIService();
 *
 * apiService.clientUsers.get(1255)...etc
 *
 *
 */

@Injectable({providedIn: 'root'})
export class APIService {
  // Resources Available to the API Service
  public clients: ClientsService;
  public clientUsers: ClientUsersService;
  public clientRoles: ClientRolesService;
  public adminUsers: AdminUsersService;
  public geoPriorities: GeoPrioritiesService;
  public geoIpExceptions: GeoIpExceptionsService;
  public regulations: RegulationsService;
  public geoRegulationMaps: GeoRegulationMapsService;
  public consentPermissions: ConsentPermissionsService;
  public complianceInputs: ComplianceInputService;
  public clientWebhooks: ClientWebhooksService;
  public businessUnits: BusinessUnitsService;
  public clientSystems: ClientSystemsService;
  public clientForms: ClientFormsService;
  public legalActivityErrors: LegalActivityErrorsService;
  public legalActivities: LegalActivitiesService;
  public clientRegulations: ClientRegulationsService;
  public clientRegulationConfigurations: ClientRegulationConfigurationsService;
  public rightRequestConfigs: RightRequestConfigsService;
  public clientEmailTemplates: ClientEmailTemplatesService;
  public forgottenUsers: ForgottenUsersService;
  public rightRequests: RightRequestService;
  public hitlTemplates: HitlTemplatesService;
  public hitlTasks: HitlTasksService;
  public geoSummaries : GeoSummaryService;
  public corePreference: CorePreferencesService;
  public corePreferenceIntegration: CorePreferenceIntegrationService;
  public coreContact: CoreContactService;
  public preferenceChannel: PreferenceChannelService;
  public preferenceWhitelist: PreferenceWhitelistService;
  public preferenceFrequency: PreferenceFrequenciesService;
    public preferenceAgents: PreferenceAgentsService;
    public preferencePage: PreferencePageService;
    public aiPreferencePage: AIPreferencePageService;
    public aiPrompt: AIPromptService;
  public preferenceForm: PreferenceFormService;
  public preferenceCatalog: PreferenceCatalogService;
  public preferenceOption: PreferenceOptionService;
  public contact: ContactService;
  public contactDetails: ContactDetailsService;
  public contactDetailsHistory: ContactDetailsHistoryService;
  public contactPreference: ContactPreferenceService;
    public contactPreferenceHistory: ContactPreferenceHistoryService;
    public preferenceWebhooks: PreferenceWebhookService;
    public preferenceDashboard: PreferenceDashboardService;
    public aiTokenUsage: AITokenUsageService;
    public aiAgent: AIAgentService;
    public preferenceAnalytics: PreferenceAnalyticsService;
    public preferenceFlowReport: PreferenceFlowReportService;
    public translations: TranslationsService;
    public translationSettings: TranslationSettingsService;
    public notifications: NotificationsService;

  /**
   * Instantiate every service so it is easily available
   * @param httpClient
   */
    constructor(httpClient: HttpClient) {
        this.clients = new ClientsService(httpClient);
        this.clientUsers = new ClientUsersService(httpClient);
        this.clientRoles = new ClientRolesService(httpClient);
        this.adminUsers = new AdminUsersService(httpClient);
        this.geoPriorities = new GeoPrioritiesService(httpClient);
        this.geoIpExceptions = new GeoIpExceptionsService(httpClient);
        this.regulations = new RegulationsService(httpClient);
        this.geoRegulationMaps = new GeoRegulationMapsService(httpClient);
        this.consentPermissions = new ConsentPermissionsService(httpClient);
        this.complianceInputs = new ComplianceInputService(httpClient);
        this.businessUnits = new BusinessUnitsService(httpClient);
        this.clientWebhooks = new ClientWebhooksService(httpClient);
        this.clientSystems = new ClientSystemsService(httpClient);
        this.clientForms = new ClientFormsService(httpClient);
        this.legalActivityErrors = new LegalActivityErrorsService(httpClient);
        this.legalActivities = new LegalActivitiesService(httpClient);
        this.clientRegulations = new ClientRegulationsService(httpClient);
        this.clientRegulationConfigurations = new ClientRegulationConfigurationsService(httpClient);
        this.rightRequestConfigs = new RightRequestConfigsService(httpClient);
        this.clientEmailTemplates = new ClientEmailTemplatesService(httpClient);
        this.forgottenUsers = new ForgottenUsersService(httpClient);
        this.rightRequests = new RightRequestService(httpClient);
        this.hitlTemplates = new HitlTemplatesService(httpClient);
        this.hitlTasks = new HitlTasksService(httpClient);
        this.geoSummaries = new GeoSummaryService(httpClient);
        this.preferenceChannel = new PreferenceChannelService(httpClient);
        this.preferenceWhitelist = new PreferenceWhitelistService(httpClient);
        this.preferenceFrequency = new PreferenceFrequenciesService(httpClient);
        this.coreContact = new CoreContactService(httpClient);
        this.corePreference = new CorePreferencesService(httpClient);
        this.corePreferenceIntegration = new CorePreferenceIntegrationService(httpClient);
        this.preferenceAgents = new PreferenceAgentsService(httpClient);
        this.preferencePage = new PreferencePageService(httpClient);
        this.aiPreferencePage = new AIPreferencePageService(httpClient);
        this.preferenceForm = new PreferenceFormService(httpClient);
        this.preferenceCatalog = new PreferenceCatalogService(httpClient);
        this.preferenceOption = new PreferenceOptionService(httpClient);
        this.contact = new ContactService(httpClient);
        this.contactDetails = new ContactDetailsService(httpClient);
        this.contactDetailsHistory = new ContactDetailsHistoryService(httpClient);
        this.contactPreference = new ContactPreferenceService(httpClient);
        this.contactPreferenceHistory = new ContactPreferenceHistoryService(httpClient);
        this.preferenceWebhooks = new PreferenceWebhookService(httpClient);
        this.preferenceDashboard = new PreferenceDashboardService(httpClient);
        this.aiPrompt = new AIPromptService(httpClient);
        this.aiTokenUsage = new AITokenUsageService(httpClient);
        this.aiAgent = new AIAgentService(httpClient);
        this.preferenceAnalytics = new PreferenceAnalyticsService(httpClient);
        this.preferenceFlowReport = new PreferenceFlowReportService(httpClient);
        this.translations = new TranslationsService(httpClient);
        this.translationSettings = new TranslationSettingsService(httpClient);
        this.notifications = new NotificationsService(httpClient);
    }
}
